import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import SystemTabs from '../../../ui/SystemTabs';
import CabecalhoTab from './tabs/CabecalhoTab';
import ArquivosTab from './tabs/ArquivosTab';
import EditorTab from './tabs/EditorTab';
export default function Form({ tipo, cadastro: c, arquivos: a, redacao: r, permissoes, parametro, isMobile, abaInicial }) {
    const editorBloqueado = r.pendente || r.ocupado;
    const cabecalhoBloqueado = !c.podeSalvar || c.isSubmitting || a.carregando || a.pendente || a.trabalhando || editorBloqueado;
    return (
        <Box
            component="form"
            onSubmit={(e) => {
                if (a.trabalhando || a.carregando || editorBloqueado) {
                    e.preventDefault();
                    return;
                }
                c.salvar(e, a.pendente);
            }}
            sx={{ minWidth: 0 }}
        >
            <Typography variant="h5">{tipo ? 'Tipo de Documento' : 'Arquivo de Documentos'}</Typography>
            {!c.podeSalvar && (
                <Alert severity="info" sx={{ mt: 2 }}>
                    Consulta sem permissão de alteração do cabeçalho.
                </Alert>
            )}
            <SystemTabs
                initialKey={tipo ? 'cabecalho' : abaInicial}
                tabs={[
                    {
                        key: 'cabecalho',
                        label: 'Cabeçalho',
                        panel: <CabecalhoTab tipo={tipo} modulo={c} bloqueado={cabecalhoBloqueado} />,
                    },
                    !tipo && {
                        key: 'arquivos',
                        label: 'Arquivos',
                        panel: editorBloqueado ? (
                            <Alert severity="info">Conclua ou descarte as alterações na aba Editor para usar os arquivos.</Alert>
                        ) : (
                            <ArquivosTab
                                modulo={a}
                                documento={c.salvos}
                                permissoes={permissoes}
                                parametro={parametro}
                                isMobile={isMobile}
                                cabecalhoPendente={c.sujo}
                            />
                        ),
                    },
                    !tipo && {
                        key: 'editor',
                        label: 'Editor',
                        panel: (
                            <EditorTab modulo={r} arquivos={a} documento={c.salvos} parametro={parametro} isMobile={isMobile} />
                        ),
                    },
                ]}
            />
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 2 }}>
                <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    disabled={c.isSubmitting || a.trabalhando || a.carregando || r.ocupado}
                    onClick={() => {
                        if (
                            (c.sujo || a.pendente || r.pendente) &&
                            !window.confirm('Sair e descartar as alterações ainda não salvas?')
                        )
                            return;
                        c.voltar();
                    }}
                >
                    Voltar
                </Button>
                {!tipo && !c.editando && c.podeSalvar && (
                    <Button
                        type="button"
                        variant="outlined"
                        disabled={!c.podeSalvar || c.isSubmitting || a.pendente || a.trabalhando || editorBloqueado}
                        onClick={(e) => c.salvar(e, a.pendente, true)}
                    >
                        Salvar e anexar
                    </Button>
                )}
                {c.podeSalvar && (
                    <Button
                        type="submit"
                        variant="contained"
                        color="success"
                        disabled={
                            !c.podeSalvar || c.isSubmitting || a.pendente || a.trabalhando || a.carregando || editorBloqueado
                        }
                    >
                        {c.isSubmitting ? 'Salvando...' : c.editando ? 'Atualizar' : 'Cadastrar'}
                    </Button>
                )}
            </Stack>
        </Box>
    );
}
